<template>
  <b-switch :value="sign.isArchived" @click.native="onSignArchiveToggle($event)">
  </b-switch>
</template>


<script>
import { mapState, mapActions } from 'vuex'
import { archiveSign, unarchiveSign } from '@/store/modules/signs'
import { canArchiveSigns } from '@/services/permissions'

export default {
  name: 'ima-sign-archive-button',
  props: {
    sign: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState(['signs']),
    canArchiveSigns () {
      return canArchiveSigns()
    }
  },
  methods: {
    ...mapActions([archiveSign, unarchiveSign]),
    onSignArchiveToggle ($event) {
      $event.preventDefault()
      if (this.signs.isSaving) {
        return
      }
      if (this.sign.isArchived) {
        this.unarchiveSign(this.sign)
      } else {
        this.archiveSign(this.sign)
      }
    }
  },
  data () {
    return {}
  }
}
</script>


<style lang="scss">
@import '../scss/settings';
</style>



// WEBPACK FOOTER //
// src/components/SignArchiveButton.vue